const indiaConfig = {
  production: {
    hostname: 'https://api.dominos.co.in',
    GOOGLE_CLIENT_ID:
      '928101681689-fhhil6jq8g1ftone3bdrt3gfq03bilob.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '534179770043053',
    API_KEY: 'd2aeb489bb8df385',
    DESKTOP_API_KEY:'X24EZOH3IL',
    IRCTC_API_KEY: '0149853ca6742cb1',
    PAYTM_API_KEY: 'YLVHY0AUFQ',
    GPAY_API_KEY: 'BUOUSB11R9',
    CLIENT_TYPE: 'web app-chrome',
    PAYTM_CLIENT_TYPE: 'web app-paytm',
    GPAY_CLIENT_TYPE: 'web app-gpay',
    GTM_TAG: 'GTM-WL89TH7',
    GTM_TAG2: 'GTM-W6SX94W',
    GTM_TAG_MICROAPP: 'GTM-THD79PK',
    GTM_TAG_GPAY: 'GTM-N276S4P',
    domain: 'https://m.dominos.co.in',
    AMPLITUDE_API_KEY: '22b51b98c3b678e3bb43761e835025fb',
    AMPLITUDE_API_KEY_PWA: '22b51b98c3b678e3bb43761e835025fb',
    AMPLITUDE_API_KEY_DESKTOP: 'ff201f6f6c8100d736dff4ce304fa819',
    AMPLITUDE_API_KEY_GPAY: '6c9ffced036c463277091d4c3b655e71',
    AMPLITUDE_API_KEY_PAYTM: 'c21290a6ae8e6b467fce2ae0ad4b8f7e',
    VWO_ACCOUNT_ID: '551982',
    AMPLITUDE_INSTANCE_NAME: 'dominos_pwa',
    userActivityTrackingSwitch: 'false',
    RAZOR_SALT_ID: '5sga2h',
    APP_INSTANCE: '71346f376e396231',
    SECRET_KEY: 'd3e5f7',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    EXPERIMENT_MAIN_ACCOUNT_ID: '6fdda7bc-9422-4a6c-839b-44cebfbf2d89',
    EXPERIMENT_TENANAT_ID: 'e426d38c-15db-420f-bcf0-753f0fb8f12d',
    EXPERIMENT_WORKSPACE_ID: 'b4af5af4-ea64-42b4-99f8-73acb700e05e',
    EXPERIMENT_API: 'https://api.dominos.co.in/experiment-labs-service/ext/v1/variation',
    MOENGAGE_APP_ID: '7H8YBFR96GL05OOCI0ZP59G9'
  },
  uat: {
    hostname: 'https://uat.dominos.co.in',
    GOOGLE_CLIENT_ID:
      '659528796466-rq1qe5jfibn7evin18knvr5n91mfkroj.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '534179770043053',
    API_KEY: '7369702fc2a34276',
    DESKTOP_API_KEY:'8LRW681B6D',
    IRCTC_API_KEY: '0149853ca6742cb1',
    PAYTM_API_KEY: '7POH70U51P',
    GPAY_API_KEY: 'P5Z1R5SLE9',
    CLIENT_TYPE: 'web app-chrome',
    PAYTM_CLIENT_TYPE: 'web app-paytm',
    GPAY_CLIENT_TYPE: 'web app-gpay',
    GTM_TAG: 'GTM-NPW9XCV',
    GTM_TAG_MICROAPP: 'GTM-THD79PK',
    GTM_TAG_GPAY: 'GTM-N276S4P',
    domain: 'https://uat-csr-pwa.dominosindia.in',
    AMPLITUDE_API_KEY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PWA: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_DESKTOP: 'ff201f6f6c8100d736dff4ce304fa819',
    AMPLITUDE_API_KEY_GPAY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PAYTM: 'eb5620e68d5fa570a077fcf9cde1080d',
    VWO_ACCOUNT_ID: '551982',
    AMPLITUDE_INSTANCE_NAME: 'dominos_pwa',
    userActivityTrackingSwitch: 'false',
    RAZOR_SALT_ID: '1a2b3c',
    APP_INSTANCE: '71346f376e396231',
    SECRET_KEY: 'd3e5f7',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    EXPERIMENT_MAIN_ACCOUNT_ID: '6fdda7bc-9422-4a6c-839b-44cebfbf2d89',
    EXPERIMENT_TENANAT_ID: 'e426d38c-15db-420f-bcf0-753f0fb8f12d',
    EXPERIMENT_WORKSPACE_ID: 'b4af5af4-ea64-42b4-99f8-73acb700e05e',
    EXPERIMENT_API: 'https://api.dominos.co.in/experiment-labs-service/ext/v1/variation',
    MOENGAGE_APP_ID: '7H8YBFR96GL05OOCI0ZP59G9'
  },
  dev0: {
    hostname: 'https://api-labsdev0.dominosindia.in',
    GOOGLE_CLIENT_ID:
      '928101681689-fhhil6jq8g1ftone3bdrt3gfq03bilob.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '534179770043053',
    API_KEY: '1be746dc5827cf05',
    DESKTOP_API_KEY:'JKUU0C5XY6',
    IRCTC_API_KEY: '0149853ca6742cb1',
    PAYTM_API_KEY: 'gE0AOxgAwW',
    GPAY_API_KEY: 'ZNQFCSR7CJ',
    CLIENT_TYPE: 'web app-chrome',
    PAYTM_CLIENT_TYPE: 'web app-paytm',
    GPAY_CLIENT_TYPE: 'web app-gpay',
    GTM_TAG: 'GTM-NPW9XCV',
    GTM_TAG_MICROAPP: 'GTM-THD79PK',
    GTM_TAG_GPAY: 'GTM-N276S4P',
    domain: 'https://dev2-new-pwa.dominosindia.in',
    AMPLITUDE_API_KEY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PWA: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_DESKTOP: 'ff201f6f6c8100d736dff4ce304fa819',
    AMPLITUDE_API_KEY_GPAY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PAYTM: 'eb5620e68d5fa570a077fcf9cde1080d',
    VWO_ACCOUNT_ID: '551982',
    AMPLITUDE_INSTANCE_NAME: 'dominos_pwa',
    RAZOR_SALT_ID: '1a2b3c',
    APP_INSTANCE: '71346f376e396231',
    SECRET_KEY: 'd3e5f7',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    MOENGAGE_APP_ID: '7H8YBFR96GL05OOCI0ZP59G9'
  },
  dev2: {
    hostname: 'https://api-dev-2.dominosindia.in',
    GOOGLE_CLIENT_ID:
      '928101681689-fhhil6jq8g1ftone3bdrt3gfq03bilob.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '534179770043053',
    API_KEY: '1be746dc5827cf05',
    DESKTOP_API_KEY:'JKUU0C5XY6',
    PAYTM_API_KEY: 'gE0AOxgAwW',
    IRCTC_API_KEY: '0149853ca6742cb1',
    GPAY_API_KEY: 'ZNQFCSR7CJ',
    CLIENT_TYPE: 'web app-chrome',
    PAYTM_CLIENT_TYPE: 'web app-paytm',
    GPAY_CLIENT_TYPE: 'web app-gpay',
    GTM_TAG: 'GTM-NPW9XCV',
    GTM_TAG_MICROAPP: 'GTM-THD79PK',
    GTM_TAG_GPAY: 'GTM-N276S4P',
    domain: 'https://dev2-new-pwa.dominosindia.in',
    AMPLITUDE_API_KEY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PWA: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_DESKTOP: 'ff201f6f6c8100d736dff4ce304fa819',
    AMPLITUDE_API_KEY_GPAY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PAYTM: 'eb5620e68d5fa570a077fcf9cde1080d',
    VWO_ACCOUNT_ID: '551982',
    AMPLITUDE_INSTANCE_NAME: 'dominos_pwa',
    RAZOR_SALT_ID: '1a2b3c',
    APP_INSTANCE: '71346f376e396231',
    SECRET_KEY: 'd3e5f7',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    MOENGAGE_APP_ID: '7H8YBFR96GL05OOCI0ZP59G9'
  },
  dev4: {
    hostname: 'https://dev4.dominosindia.in',
    GOOGLE_CLIENT_ID:
      '928101681689-fhhil6jq8g1ftone3bdrt3gfq03bilob.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '534179770043053',
    API_KEY: '1be746dc5827cf05',
    DESKTOP_API_KEY:'JKUU0C5XY6',
    PAYTM_API_KEY: 'gE0AOxgAwW',
    IRCTC_API_KEY: '0149853ca6742cb1',
    GPAY_API_KEY: 'ZNQFCSR7CJ',
    CLIENT_TYPE: 'web app-chrome',
    PAYTM_CLIENT_TYPE: 'web app-paytm',
    GPAY_CLIENT_TYPE: 'web app-gpay',
    GTM_TAG: 'GTM-NPW9XCV',
    GTM_TAG_MICROAPP: 'GTM-THD79PK',
    GTM_TAG_GPAY: 'GTM-N276S4P',
    domain: 'https://dev4-csr-pwa.dominosindia.in',
    AMPLITUDE_API_KEY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PWA: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_DESKTOP: 'ff201f6f6c8100d736dff4ce304fa819',
    AMPLITUDE_API_KEY_GPAY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PAYTM: 'eb5620e68d5fa570a077fcf9cde1080d',
    VWO_ACCOUNT_ID: '551982',
    AMPLITUDE_INSTANCE_NAME: 'dominos_pwa',
    userActivityTrackingSwitch: 'false',
    RAZOR_SALT_ID: '1a2b3c',
    APP_INSTANCE: '71346f376e396231',
    SECRET_KEY: 'd3e5f7',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    MOENGAGE_APP_ID: '7H8YBFR96GL05OOCI0ZP59G9'
  },
  dev5: {
    hostname: 'https://dev5.dominosindia.in',
    GOOGLE_CLIENT_ID:
      '928101681689-fhhil6jq8g1ftone3bdrt3gfq03bilob.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '534179770043053',
    API_KEY: '1be746dc5827cf05',
    DESKTOP_API_KEY:'JKUU0C5XY6',
    PAYTM_API_KEY: 'gE0AOxgAwW',
    IRCTC_API_KEY: '0149853ca6742cb1',
    GPAY_API_KEY: 'ZNQFCSR7CJ',
    CLIENT_TYPE: 'web app-chrome',
    PAYTM_CLIENT_TYPE: 'web app-paytm',
    GPAY_CLIENT_TYPE: 'web app-gpay',
    GTM_TAG: 'GTM-NPW9XCV',
    GTM_TAG_MICROAPP: 'GTM-THD79PK',
    GTM_TAG_GPAY: 'GTM-N276S4P',
    domain: 'https://dev5-csr-pwa.dominosindia.in',
    AMPLITUDE_API_KEY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PWA: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_DESKTOP: 'ff201f6f6c8100d736dff4ce304fa819',
    AMPLITUDE_API_KEY_GPAY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PAYTM: 'eb5620e68d5fa570a077fcf9cde1080d',
    VWO_ACCOUNT_ID: '551982',
    AMPLITUDE_INSTANCE_NAME: 'dominos_pwa',
    RAZOR_SALT_ID: '1a2b3c',
    APP_INSTANCE: '71346f376e396231',
    SECRET_KEY: 'd3e5f7',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    MOENGAGE_APP_ID: '7H8YBFR96GL05OOCI0ZP59G9'
  },
  dev6: {
    hostname: 'https://dev6.dominosindia.in',
    GOOGLE_CLIENT_ID:
      '928101681689-fhhil6jq8g1ftone3bdrt3gfq03bilob.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '534179770043053',
    API_KEY: '1be746dc5827cf05',
    DESKTOP_API_KEY:'JKUU0C5XY6',
    PAYTM_API_KEY: 'gE0AOxgAwW',
    IRCTC_API_KEY: '0149853ca6742cb1',
    GPAY_API_KEY: 'ZNQFCSR7CJ',
    CLIENT_TYPE: 'web app-chrome',
    PAYTM_CLIENT_TYPE: 'web app-paytm',
    GPAY_CLIENT_TYPE: 'web app-gpay',
    GTM_TAG: 'GTM-NPW9XCV',
    GTM_TAG_MICROAPP: 'GTM-THD79PK',
    GTM_TAG_GPAY: 'GTM-N276S4P',
    domain: 'https://dev6-csr-pwa.dominosindia.in',
    AMPLITUDE_API_KEY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PWA: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_DESKTOP: 'ff201f6f6c8100d736dff4ce304fa819',
    AMPLITUDE_API_KEY_GPAY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PAYTM: 'eb5620e68d5fa570a077fcf9cde1080d',
    VWO_ACCOUNT_ID: '551982',
    AMPLITUDE_INSTANCE_NAME: 'dominos_pwa',
    userActivityTrackingSwitch: 'false',
    RAZOR_SALT_ID: '1a2b3c',
    APP_INSTANCE: '71346f376e396231',
    SECRET_KEY: 'd3e5f7',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    MOENGAGE_APP_ID: '7H8YBFR96GL05OOCI0ZP59G9'
  },
  stage: {
    hostname: 'https://s0.dominosindia.in',
    GOOGLE_CLIENT_ID:
      '928101681689-fhhil6jq8g1ftone3bdrt3gfq03bilob.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '534179770043053',
    API_KEY: '1be746dc5827cf05',
    DESKTOP_API_KEY:'JKUU0C5XY6',
    IRCTC_API_KEY: '0149853ca6742cb1',
    PAYTM_API_KEY: 'gE0AOxgAwW',
    GPAY_API_KEY: 'ZNQFCSR7CJ',
    CLIENT_TYPE: 'web app-chrome',
    PAYTM_CLIENT_TYPE: 'web app-paytm',
    GPAY_CLIENT_TYPE: 'web app-gpay',
    GTM_TAG: 'GTM-NPW9XCV',
    GTM_TAG_MICROAPP: 'GTM-THD79PK',
    GTM_TAG_GPAY: 'GTM-N276S4P',
    domain: 'https://beta-pwa.dominosindia.in',
    AMPLITUDE_API_KEY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PWA: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_DESKTOP: 'ff201f6f6c8100d736dff4ce304fa819',
    AMPLITUDE_API_KEY_GPAY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PAYTM: 'eb5620e68d5fa570a077fcf9cde1080d',
    VWO_ACCOUNT_ID: '551982',
    AMPLITUDE_INSTANCE_NAME: 'dominos_pwa',
    userActivityTrackingSwitch: 'false',
    RAZOR_SALT_ID: '1a2b3c',
    APP_INSTANCE: '71346f376e396231',
    SECRET_KEY: 'd3e5f7',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    EXPERIMENT_MAIN_ACCOUNT_ID: '6fdda7bc-9422-4a6c-839b-44cebfbf2d89',
    EXPERIMENT_TENANAT_ID: 'e426d38c-15db-420f-bcf0-753f0fb8f12d',
    EXPERIMENT_WORKSPACE_ID: 'b4af5af4-ea64-42b4-99f8-73acb700e05e',
    EXPERIMENT_API: 'https://api.dominos.co.in/experiment-labs-service/ext/v1/variation',
    MOENGAGE_APP_ID: '7H8YBFR96GL05OOCI0ZP59G9'
  },
  stage1: {
    hostname: 'https://s1-labs.dominosindia.in',
    GOOGLE_CLIENT_ID:
      '928101681689-fhhil6jq8g1ftone3bdrt3gfq03bilob.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '534179770043053',
    API_KEY: '1be746dc5827cf05',
    DESKTOP_API_KEY:'JKUU0C5XY6',
    IRCTC_API_KEY: '0149853ca6742cb1',
    PAYTM_API_KEY: 'gE0AOxgAwW',
    GPAY_API_KEY: 'ZNQFCSR7CJ',
    CLIENT_TYPE: 'web app-chrome',
    PAYTM_CLIENT_TYPE: 'web app-paytm',
    GPAY_CLIENT_TYPE: 'web app-gpay',
    GTM_TAG: 'GTM-NPW9XCV',
    GTM_TAG_MICROAPP: 'GTM-THD79PK',
    GTM_TAG_GPAY: 'GTM-N276S4P',
    domain: 'https://beta-pwa.dominosindia.in',
    AMPLITUDE_API_KEY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PWA: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_DESKTOP: 'ff201f6f6c8100d736dff4ce304fa819',
    AMPLITUDE_API_KEY_GPAY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PAYTM: 'eb5620e68d5fa570a077fcf9cde1080d',
    VWO_ACCOUNT_ID: '551982',
    AMPLITUDE_INSTANCE_NAME: 'dominos_pwa',
    userActivityTrackingSwitch: 'false',
    RAZOR_SALT_ID: '1a2b3c',
    APP_INSTANCE: '71346f376e396231',
    SECRET_KEY: 'd3e5f7',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    EXPERIMENT_MAIN_ACCOUNT_ID: '6fdda7bc-9422-4a6c-839b-44cebfbf2d89',
    EXPERIMENT_TENANAT_ID: 'e426d38c-15db-420f-bcf0-753f0fb8f12d',
    EXPERIMENT_WORKSPACE_ID: 'b4af5af4-ea64-42b4-99f8-73acb700e05e',
    EXPERIMENT_API: 'https://api.dominos.co.in/experiment-labs-service/ext/v1/variation',
    MOENGAGE_APP_ID: '7H8YBFR96GL05OOCI0ZP59G9'
  },
  stage2: {
    hostname: 'https://s2-labs.dominosindia.in',
    GOOGLE_CLIENT_ID:
      '928101681689-fhhil6jq8g1ftone3bdrt3gfq03bilob.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '534179770043053',
    API_KEY: '1be746dc5827cf05',
    DESKTOP_API_KEY:'JKUU0C5XY6',
    IRCTC_API_KEY: '0149853ca6742cb1',
    PAYTM_API_KEY: 'gE0AOxgAwW',
    GPAY_API_KEY: 'ZNQFCSR7CJ',
    CLIENT_TYPE: 'web app-chrome',
    PAYTM_CLIENT_TYPE: 'web app-paytm',
    GPAY_CLIENT_TYPE: 'web app-gpay',
    GTM_TAG: 'GTM-NPW9XCV',
    GTM_TAG_MICROAPP: 'GTM-THD79PK',
    GTM_TAG_GPAY: 'GTM-N276S4P',
    domain: 'https://s2-pwa.dominosindia.in',
    AMPLITUDE_API_KEY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PWA: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_DESKTOP: 'ff201f6f6c8100d736dff4ce304fa819',
    AMPLITUDE_API_KEY_GPAY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PAYTM: 'eb5620e68d5fa570a077fcf9cde1080d',
    VWO_ACCOUNT_ID: '551982',
    AMPLITUDE_INSTANCE_NAME: 'dominos_pwa',
    userActivityTrackingSwitch: 'false',
    RAZOR_SALT_ID: '1a2b3c',
    APP_INSTANCE: '71346f376e396231',
    SECRET_KEY: 'd3e5f7',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    EXPERIMENT_MAIN_ACCOUNT_ID: '6fdda7bc-9422-4a6c-839b-44cebfbf2d89',
    EXPERIMENT_TENANAT_ID: 'e426d38c-15db-420f-bcf0-753f0fb8f12d',
    EXPERIMENT_WORKSPACE_ID: 'b4af5af4-ea64-42b4-99f8-73acb700e05e',
    EXPERIMENT_API: 'https://api.dominos.co.in/experiment-labs-service/ext/v1/variation',
    MOENGAGE_APP_ID: '7H8YBFR96GL05OOCI0ZP59G9'
  },
  stage3: {
    hostname: 'https://s3.dominosindia.in',
    GOOGLE_CLIENT_ID:
      '928101681689-fhhil6jq8g1ftone3bdrt3gfq03bilob.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '534179770043053',
    API_KEY: '1be746dc5827cf05',
    DESKTOP_API_KEY:'JKUU0C5XY6',
    IRCTC_API_KEY: '0149853ca6742cb1',
    PAYTM_API_KEY: 'gE0AOxgAwW',
    GPAY_API_KEY: 'ZNQFCSR7CJ',
    CLIENT_TYPE: 'web app-chrome',
    PAYTM_CLIENT_TYPE: 'web app-paytm',
    GPAY_CLIENT_TYPE: 'web app-gpay',
    GTM_TAG: 'GTM-NPW9XCV',
    GTM_TAG_MICROAPP: 'GTM-THD79PK',
    GTM_TAG_GPAY: 'GTM-N276S4P',
    domain: 'https://s3-pwa.dominosindia.in',
    AMPLITUDE_API_KEY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PWA: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_DESKTOP: 'ff201f6f6c8100d736dff4ce304fa819',
    AMPLITUDE_API_KEY_GPAY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PAYTM: 'eb5620e68d5fa570a077fcf9cde1080d',
    VWO_ACCOUNT_ID: '551982',
    AMPLITUDE_INSTANCE_NAME: 'dominos_pwa',
    userActivityTrackingSwitch: 'false',
    RAZOR_SALT_ID: '1a2b3c',
    APP_INSTANCE: '71346f376e396231',
    SECRET_KEY: 'd3e5f7',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    EXPERIMENT_MAIN_ACCOUNT_ID: '6fdda7bc-9422-4a6c-839b-44cebfbf2d89',
    EXPERIMENT_TENANAT_ID: 'e426d38c-15db-420f-bcf0-753f0fb8f12d',
    EXPERIMENT_WORKSPACE_ID: 'b4af5af4-ea64-42b4-99f8-73acb700e05e',
    EXPERIMENT_API: 'https://api.dominos.co.in/experiment-labs-service/ext/v1/variation',
    MOENGAGE_APP_ID: '7H8YBFR96GL05OOCI0ZP59G9'
  },
  stage4: {
    hostname: ' https://s4.dominosindia.in',
    GOOGLE_CLIENT_ID:
      '928101681689-fhhil6jq8g1ftone3bdrt3gfq03bilob.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '534179770043053',
    API_KEY: '1be746dc5827cf05',
    DESKTOP_API_KEY:'JKUU0C5XY6',
    IRCTC_API_KEY: '0149853ca6742cb1',
    PAYTM_API_KEY: 'gE0AOxgAwW',
    GPAY_API_KEY: 'ZNQFCSR7CJ',
    CLIENT_TYPE: 'web app-chrome',
    PAYTM_CLIENT_TYPE: 'web app-paytm',
    GPAY_CLIENT_TYPE: 'web app-gpay',
    GTM_TAG: 'GTM-NPW9XCV',
    GTM_TAG_MICROAPP: 'GTM-THD79PK',
    GTM_TAG_GPAY: 'GTM-N276S4P',
    domain: 'https://beta-pwa.dominosindia.in',
    AMPLITUDE_API_KEY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PWA: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_DESKTOP: 'ff201f6f6c8100d736dff4ce304fa819',
    AMPLITUDE_API_KEY_GPAY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PAYTM: 'eb5620e68d5fa570a077fcf9cde1080d',
    VWO_ACCOUNT_ID: '551982',
    AMPLITUDE_INSTANCE_NAME: 'dominos_pwa',
    userActivityTrackingSwitch: 'false',
    RAZOR_SALT_ID: '1a2b3c',
    APP_INSTANCE: '71346f376e396231',
    SECRET_KEY: 'd3e5f7',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    EXPERIMENT_MAIN_ACCOUNT_ID: '6fdda7bc-9422-4a6c-839b-44cebfbf2d89',
    EXPERIMENT_TENANAT_ID: 'e426d38c-15db-420f-bcf0-753f0fb8f12d',
    EXPERIMENT_WORKSPACE_ID: 'b4af5af4-ea64-42b4-99f8-73acb700e05e',
    EXPERIMENT_API: 'https://api.dominos.co.in/experiment-labs-service/ext/v1/variation',
    MOENGAGE_APP_ID: '7H8YBFR96GL05OOCI0ZP59G9'
  },
  stage6: {
    hostname: 'https://s6-labs.dominosindia.in',
    GOOGLE_CLIENT_ID:
      '928101681689-fhhil6jq8g1ftone3bdrt3gfq03bilob.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '534179770043053',
    API_KEY: '1be746dc5827cf05',
    DESKTOP_API_KEY:'JKUU0C5XY6',
    IRCTC_API_KEY: '0149853ca6742cb1',
    PAYTM_API_KEY: 'gE0AOxgAwW',
    GPAY_API_KEY: 'ZNQFCSR7CJ',
    CLIENT_TYPE: 'web app-chrome',
    PAYTM_CLIENT_TYPE: 'web app-paytm',
    GPAY_CLIENT_TYPE: 'web app-gpay',
    GTM_TAG: 'GTM-NPW9XCV',
    GTM_TAG_MICROAPP: 'GTM-THD79PK',
    GTM_TAG_GPAY: 'GTM-N276S4P',
    domain: 'https://s6-pwa.dominosindia.in',
    AMPLITUDE_API_KEY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PWA: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_DESKTOP: 'ff201f6f6c8100d736dff4ce304fa819',
    AMPLITUDE_API_KEY_GPAY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PAYTM: 'eb5620e68d5fa570a077fcf9cde1080d',
    VWO_ACCOUNT_ID: '551982',
    AMPLITUDE_INSTANCE_NAME: 'dominos_pwa',
    userActivityTrackingSwitch: 'false',
    RAZOR_SALT_ID: '1a2b3c',
    APP_INSTANCE: '71346f376e396231',
    SECRET_KEY: 'd3e5f7',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    EXPERIMENT_MAIN_ACCOUNT_ID: '6fdda7bc-9422-4a6c-839b-44cebfbf2d89',
    EXPERIMENT_TENANAT_ID: 'e426d38c-15db-420f-bcf0-753f0fb8f12d',
    EXPERIMENT_WORKSPACE_ID: 'b4af5af4-ea64-42b4-99f8-73acb700e05e',
    EXPERIMENT_API: 'https://api.dominos.co.in/experiment-labs-service/ext/v1/variation',
    MOENGAGE_APP_ID: '7H8YBFR96GL05OOCI0ZP59G9'
  },
  stage7: {
    hostname: 'https://s7-labs.dominosindia.in',
    GOOGLE_CLIENT_ID:
      '928101681689-fhhil6jq8g1ftone3bdrt3gfq03bilob.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '534179770043053',
    API_KEY: '1be746dc5827cf05',
    DESKTOP_API_KEY:'JKUU0C5XY6',
    IRCTC_API_KEY: '0149853ca6742cb1',
    PAYTM_API_KEY: 'gE0AOxgAwW',
    GPAY_API_KEY: 'ZNQFCSR7CJ',
    CLIENT_TYPE: 'web app-chrome',
    PAYTM_CLIENT_TYPE: 'web app-paytm',
    GPAY_CLIENT_TYPE: 'web app-gpay',
    GTM_TAG: 'GTM-NPW9XCV',
    GTM_TAG_MICROAPP: 'GTM-THD79PK',
    GTM_TAG_GPAY: 'GTM-N276S4P',
    domain: 'https://s7-csr-pwa.dominosindia.in',
    AMPLITUDE_API_KEY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PWA: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_DESKTOP: 'ff201f6f6c8100d736dff4ce304fa819',
    AMPLITUDE_API_KEY_GPAY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PAYTM: 'eb5620e68d5fa570a077fcf9cde1080d',
    VWO_ACCOUNT_ID: '551982',
    AMPLITUDE_INSTANCE_NAME: 'dominos_pwa',
    userActivityTrackingSwitch: 'false',
    RAZOR_SALT_ID: '1a2b3c',
    APP_INSTANCE: '71346f376e396231',
    SECRET_KEY: 'd3e5f7',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    EXPERIMENT_MAIN_ACCOUNT_ID: '6fdda7bc-9422-4a6c-839b-44cebfbf2d89',
    EXPERIMENT_TENANAT_ID: 'e426d38c-15db-420f-bcf0-753f0fb8f12d',
    EXPERIMENT_WORKSPACE_ID: 'b4af5af4-ea64-42b4-99f8-73acb700e05e',
    EXPERIMENT_API: 'https://api.dominos.co.in/experiment-labs-service/ext/v1/variation',
    MOENGAGE_APP_ID: '7H8YBFR96GL05OOCI0ZP59G9'
  },
  stage8: {
    hostname: 'https://s8-labs.dominosindia.in',
    GOOGLE_CLIENT_ID:
      '928101681689-fhhil6jq8g1ftone3bdrt3gfq03bilob.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '534179770043053',
    API_KEY: '1be746dc5827cf05',
    DESKTOP_API_KEY:'JKUU0C5XY6',
    IRCTC_API_KEY: '0149853ca6742cb1',
    PAYTM_API_KEY: 'gE0AOxgAwW',
    GPAY_API_KEY: 'ZNQFCSR7CJ',
    CLIENT_TYPE: 'web app-chrome',
    PAYTM_CLIENT_TYPE: 'web app-paytm',
    GPAY_CLIENT_TYPE: 'web app-gpay',
    GTM_TAG: 'GTM-NPW9XCV',
    GTM_TAG_MICROAPP: 'GTM-THD79PK',
    GTM_TAG_GPAY: 'GTM-N276S4P',
    domain: 'https://s8-csr-pwa.dominosindia.in',
    AMPLITUDE_API_KEY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PWA: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_DESKTOP: 'ff201f6f6c8100d736dff4ce304fa819',
    AMPLITUDE_API_KEY_GPAY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PAYTM: 'eb5620e68d5fa570a077fcf9cde1080d',
    VWO_ACCOUNT_ID: '551982',
    AMPLITUDE_INSTANCE_NAME: 'dominos_pwa',
        userActivityTrackingSwitch: 'false',
    RAZOR_SALT_ID: '1a2b3c',
    APP_INSTANCE: '71346f376e396231',
    SECRET_KEY: 'd3e5f7',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    EXPERIMENT_MAIN_ACCOUNT_ID: '6fdda7bc-9422-4a6c-839b-44cebfbf2d89',
    EXPERIMENT_TENANAT_ID: 'e426d38c-15db-420f-bcf0-753f0fb8f12d',
    EXPERIMENT_WORKSPACE_ID: 'b4af5af4-ea64-42b4-99f8-73acb700e05e',
    EXPERIMENT_API: 'https://api.dominos.co.in/experiment-labs-service/ext/v1/variation',
    MOENGAGE_APP_ID: '7H8YBFR96GL05OOCI0ZP59G9'
  },
  stage9: {
    hostname: 'https://s9-labs.dominosindia.in',
    GOOGLE_CLIENT_ID:
      '928101681689-fhhil6jq8g1ftone3bdrt3gfq03bilob.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '534179770043053',
    API_KEY: '1be746dc5827cf05',
    DESKTOP_API_KEY:'JKUU0C5XY6',
    IRCTC_API_KEY: '0149853ca6742cb1',
    PAYTM_API_KEY: 'gE0AOxgAwW',
    GPAY_API_KEY: 'ZNQFCSR7CJ',
    CLIENT_TYPE: 'web app-chrome',
    PAYTM_CLIENT_TYPE: 'web app-paytm',
    GPAY_CLIENT_TYPE: 'web app-gpay',
    GTM_TAG: 'GTM-NPW9XCV',
    GTM_TAG_MICROAPP: 'GTM-THD79PK',
    GTM_TAG_GPAY: 'GTM-N276S4P',
    domain: 'https://s9-csr-pwa.dominosindia.in',
    AMPLITUDE_API_KEY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PWA: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_DESKTOP: 'ff201f6f6c8100d736dff4ce304fa819',
    AMPLITUDE_API_KEY_GPAY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PAYTM: 'eb5620e68d5fa570a077fcf9cde1080d',
    VWO_ACCOUNT_ID: '551982',
    AMPLITUDE_INSTANCE_NAME: 'dominos_pwa',
        userActivityTrackingSwitch: 'false',
    RAZOR_SALT_ID: '1a2b3c',
    APP_INSTANCE: '71346f376e396231',
    SECRET_KEY: 'd3e5f7',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    EXPERIMENT_MAIN_ACCOUNT_ID: '6fdda7bc-9422-4a6c-839b-44cebfbf2d89',
    EXPERIMENT_TENANAT_ID: 'e426d38c-15db-420f-bcf0-753f0fb8f12d',
    EXPERIMENT_WORKSPACE_ID: 'b4af5af4-ea64-42b4-99f8-73acb700e05e',
    EXPERIMENT_API: 'https://api.dominos.co.in/experiment-labs-service/ext/v1/variation',
    MOENGAGE_APP_ID: '7H8YBFR96GL05OOCI0ZP59G9'
  },
  development: {
    hostname: 'https://api-labsdev1.dominosindia.in',
    GOOGLE_CLIENT_ID:
      '749977844209-83edee24mpm9d8e32lrocgst4dpsg9l2.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '534179770043053',
    API_KEY: '5dc22c0253f499ac',
    DESKTOP_API_KEY:'5dc22c0253f499ac',
    IRCTC_API_KEY: '0149853ca6742cb1',
    PAYTM_API_KEY: 'gE0AOxgAwW',
    GPAY_API_KEY: 'ZNQFCSR7CJ',
    CLIENT_TYPE: 'web app-chrome',
    PAYTM_CLIENT_TYPE: 'web app-paytm',
    GPAY_CLIENT_TYPE: 'web app-gpay',
    GTM_TAG: 'GTM-NPW9XCV',
    GTM_TAG_MICROAPP: 'GTM-THD79PK',
    GTM_TAG_GPAY: 'GTM-N276S4P',
    domain: 'https://dev-pwa.dominosindia.in',
    AMPLITUDE_API_KEY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PWA: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_DESKTOP: 'ff201f6f6c8100d736dff4ce304fa819',
    AMPLITUDE_API_KEY_GPAY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PAYTM: 'eb5620e68d5fa570a077fcf9cde1080d',
    VWO_ACCOUNT_ID: '551982',
    AMPLITUDE_INSTANCE_NAME: 'dominos_pwa',
    userActivityTrackingSwitch: 'true',
    RAZOR_SALT_ID: '1a2b3c',
    APP_INSTANCE: '71346f376e396231',
    SECRET_KEY: 'd3e5f7',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    MOENGAGE_APP_ID: '7H8YBFR96GL05OOCI0ZP59G9'
  },
  devcsr: {
    hostname: 'https://dev-csr-pwa.dominosindia.in',
    GOOGLE_CLIENT_ID:
      '928101681689-fhhil6jq8g1ftone3bdrt3gfq03bilob.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '534179770043053',
    API_KEY: '1be746dc5827cf05',
    DESKTOP_API_KEY:'JKUU0C5XY6',
    IRCTC_API_KEY: '0149853ca6742cb1',
    PAYTM_API_KEY: 'gE0AOxgAwW',
    GPAY_API_KEY: 'ZNQFCSR7CJ',
    CLIENT_TYPE: 'web app-chrome',
    PAYTM_CLIENT_TYPE: 'web app-paytm',
    GPAY_CLIENT_TYPE: 'web app-gpay',
    GTM_TAG: 'GTM-NPW9XCV',
    GTM_TAG_MICROAPP: 'GTM-THD79PK',
    GTM_TAG_GPAY: 'GTM-N276S4P',
    domain: 'https://dev-csr-pwa.dominosindia.in',
    AMPLITUDE_API_KEY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PWA: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_DESKTOP: 'ff201f6f6c8100d736dff4ce304fa819',
    AMPLITUDE_API_KEY_GPAY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PAYTM: 'eb5620e68d5fa570a077fcf9cde1080d',
    VWO_ACCOUNT_ID: '551982',
    AMPLITUDE_INSTANCE_NAME: 'dominos_pwa',
    RAZOR_SALT_ID: '1a2b3c',
    APP_INSTANCE: '71346f376e396231',
    SECRET_KEY: 'd3e5f7',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    MOENGAGE_APP_ID: '7H8YBFR96GL05OOCI0ZP59G9'
  },
  local: {
    hostname: 'https://api.dominosindia.in',
    GOOGLE_CLIENT_ID:
      '749977844209-83edee24mpm9d8e32lrocgst4dpsg9l2.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '534179770043053',
    API_KEY: 'cb66dd789fd1534f',
    DESKTOP_API_KEY:'f5b1592b1147d292',
    IRCTC_API_KEY: '0149853ca6742cb1',
    PAYTM_API_KEY: 'gE0AOxgAwW',
    GPAY_API_KEY: 'ZNQFCSR7CJ',
    CLIENT_TYPE: 'web app-chrome',
    PAYTM_CLIENT_TYPE: 'web app-paytm',
    GPAY_CLIENT_TYPE: 'web app-gpay',
    GTM_TAG: 'GTM-NPW9XCV',
    GTM_TAG_MICROAPP: 'GTM-THD79PK',
    GTM_TAG_GPAY: 'GTM-N276S4P',
    domain: 'http://localhost:3000',
    AMPLITUDE_API_KEY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PWA: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_DESKTOP: 'ff201f6f6c8100d736dff4ce304fa819',
    AMPLITUDE_API_KEY_GPAY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PAYTM: 'eb5620e68d5fa570a077fcf9cde1080d',
    VWO_ACCOUNT_ID: '551982',
    AMPLITUDE_INSTANCE_NAME: 'dominos_pwa',
    RAZOR_SALT_ID: '1a2b3c',
    APP_INSTANCE: '71346f376e396231',
    SECRET_KEY: 'd3e5f7',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    MOENGAGE_APP_ID: '7H8YBFR96GL05OOCI0ZP59G9'
  },
  local_stage: {
    hostname: 'https://s0.dominosindia.in',
    GOOGLE_CLIENT_ID:
      '928101681689-fhhil6jq8g1ftone3bdrt3gfq03bilob.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '534179770043053',
    API_KEY: 'fd2ed7880af4bdd2',
    DESKTOP_API_KEY:'JKUU0C5XY6',
    IRCTC_API_KEY: '0149853ca6742cb1',
    PAYTM_API_KEY: 'gE0AOxgAwW',
    GPAY_API_KEY: 'ZNQFCSR7CJ',
    CLIENT_TYPE: 'web app-chrome',
    PAYTM_CLIENT_TYPE: 'web app-paytm',
    GPAY_CLIENT_TYPE: 'web app-gpay',
    GTM_TAG: 'GTM-NPW9XCV',
    GTM_TAG_MICROAPP: 'GTM-THD79PK',
    GTM_TAG_GPAY: 'GTM-N276S4P',
    domain: 'http://localhost:3000',
    AMPLITUDE_API_KEY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PWA: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_DESKTOP: 'ff201f6f6c8100d736dff4ce304fa819',
    AMPLITUDE_API_KEY_GPAY: 'eb5620e68d5fa570a077fcf9cde1080d',
    AMPLITUDE_API_KEY_PAYTM: 'eb5620e68d5fa570a077fcf9cde1080d',
    VWO_ACCOUNT_ID: '551982',
    AMPLITUDE_INSTANCE_NAME: 'dominos_pwa',
    RAZOR_SALT_ID: '1a2b3c',
    APP_INSTANCE: '71346f376e396231',
    SECRET_KEY: 'd3e5f7',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    MOENGAGE_APP_ID: '7H8YBFR96GL05OOCI0ZP59G9'
  },
  image: {
    hostname: 'https://images.dominos.co.in/',
  },
  s3Bucket: {
    production: 'prod-olo-api',
    development: 'dev1-olo-api-bucket',
    devcsr: 's2-olo-api-bucket',
    local: 'stage-olo-api-bucket',
    dev0: 'stage-olo-api-bucket',
    dev2: 'ind-dev-2-olo-api-bucket',
    stage: 's0-olo-api',
    stage2: 's2-olo-api',
    stage3: 's3-olo-api',
    stage4: 's4-olo-api',
    stage6: 's6-olo-api',
    stage7: 's7-olo-api',
    stage8: 's8-olo-api',
    stage9: 's9-olo-api',
    stage1: 's1-olo-api',
    local_stage: 's0-olo-api-bucket',
    uat: 'uat-olo-api',
  },
  cmsSiteBucket: {
    production: 'jflcms',
    development: 'jflcms',
    devcsr: 'jflcms',
    local: 'jflcms',
    dev0: 'jflcms',
    dev2: 'jflcms',
    dev4: 'jflcms',
    dev6: 'jflcms',
    stage: 'jflcms-s0',
    stage2: 'jflcms-s2',
    stage3: 'jflcms',
    stage4: 'jflcms-s4',
    stage6: 'jflcms-s6',
    stage7: 'jflcms-s7',
    stage8: 'jflcms-s8',
    stage9: 'jflcms-s9',
    stage1: 'jflcms-s1',
    local_stage: 'jflcms-s0',
    uat: 'jflcms',
  },
  map: {
    autoComplete:
      'https://maps.googleapis.com/maps/api/place/autocomplete/json?components=country:in&region=en&key=AIzaSyDSo8kVS5Q-2YSGRxrK2LHTeSApG4SNnmU&userId=2172&input=',
  },
};

module.exports = indiaConfig;
